/**
 * The action types that end a signed-in session, as literal strings, for the
 * same reason as `tenantSwitchActionType.js`: slices and store middleware
 * that react to a logout can match on these without importing authSlice.js
 * (and, through it, the api/client -> store cycle).
 *
 * - `logoutUser` thunk: `createAsyncThunk("auth/logout", ...)` -> the
 *   "/fulfilled" and "/rejected" suffixes (a failed API call still clears
 *   local state, so both end the session).
 * - `logout` reducer: `authSlice.actions.logout` -> "auth/logout", dispatched
 *   by api/client.js on a 401.
 */
export const LOGOUT_FULFILLED = 'auth/logout/fulfilled'
export const LOGOUT_REJECTED = 'auth/logout/rejected'
export const LOGOUT = 'auth/logout'

export const LOGOUT_ACTION_TYPES = [LOGOUT_FULFILLED, LOGOUT_REJECTED, LOGOUT]
